"use client";

import React, { useEffect, useState } from "react";

import { useTranslations } from "next-intl";

import { Button } from "../Button/Button";
import { Input } from "../Input/Input";
import { Typography } from "../Typography/Typography";

type ShareLinkProps = Readonly<{
    children: React.ReactNode;
    className?: string;
    small?: boolean;
    text?: string;
    title?: string;
    withoutQueryString?: boolean;
}>;

const isShareSupported = typeof navigator !== "undefined" && navigator.share;

export function ShareLink({
    children,
    className,
    small = false,
    text,
    title,
    withoutQueryString = true,
}: ShareLinkProps) {
    const [showFallbackInput, setShowFallbackInput] = useState(!isShareSupported);
    const [href, setHref] = useState<string>();
    const t = useTranslations("Share");

    useEffect(() => {
        const hrefToSet = small
            ? window.location.protocol + "//" + window.location.host
            : withoutQueryString
              ? window.location.protocol + "//" + window.location.host + window.location.pathname
              : window.location.href;
        console.log(small, hrefToSet);
        setHref(hrefToSet);
    }, [withoutQueryString, small]);

    const handleShare = () => {
        if (isShareSupported) {
            navigator
                .share({
                    text,
                    title,
                    url: href,
                })
                .catch((error) => {
                    console.error("Error during sharing:", error);
                });
        } else {
            setShowFallbackInput(true);
        }
    };

    if (!href) {
        return null;
    }

    return (
        <div className={className} onClick={handleShare}>
            {children}
        </div>
    );
}
